/**
 * Floating shop bar — colorway sync.
 *
 * Listens for `plx:colorway` events (dispatched by plx-tour.js when a homepage
 * tour chip activates and by plx-gallery.js when a gallery filter chip is
 * chosen) and swaps the bar's thumb icon to that colorway's shot. Unless an
 * explicit link is pinned in the section settings (swapLinks: false),
 * the CTA href also retargets to that colorway's variant on the PDP.
 * Per-page only: nothing persists across navigations.
 */
(function () {
  function init() {
    var root = document.querySelector("[data-plx-shopbar]");
    if (!root) return;
    var cfgEl = root.querySelector("[data-plx-shopbar-config]");
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var thumb = root.querySelector("[data-plx-shopbar-thumb]");
    var links = Array.prototype.slice.call(
      root.querySelectorAll("[data-plx-shopbar-link]")
    );
    document.addEventListener("plx:colorway", function (e) {
      var key = e.detail && e.detail.key;
      var c = key && cfg.colorways && cfg.colorways[key];
      if (!c) return;
      if (thumb && c.thumb) thumb.src = c.thumb;
      if (cfg.swapLinks && c.link) {
        links.forEach(function (a) { a.href = c.link; });
      }
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
